export default "__VITE_ASSET__BBK2FM78__"